export default "__VITE_ASSET__CiN$ir00__"